<script>
  import { Route, Router } from "svelte-navigator";
  import { userStore } from "./store";
  import {
    AdminOnly,
    Content,
    Header,
    Sidebar,
  } from "./components/index.svelte";
  import {
    UserList,
    UserDetails,
    UserForm,
    AuthLayout,
    MainDashboard,
    CompanyList,
    CompanyDetails,
    CompanyForm,
    StockList,
    StockDetails,
    StockForm,
    OfferList,
    OfferDetails,
    OfferForm,
    OrderList,
    OrderDetails,
    OrderForm
  } from "./views/index.svelte";
  import { fade } from "svelte/transition";

</script>

<Router>
  {#if $userStore?.isLoggedIn}
    <Header />
    <Sidebar />
    <Content>
      <Router>
        <Route
          path="/"
          component={MainDashboard}
        />
        <AdminOnly>
          <Route path="/user-management/*">
            <Route path="users">
              <div in:fade>
                <UserList />
              </div>
            </Route>
            <Route path="users/new" let:params>
              <div in:fade>
                <UserForm formType="new" />
              </div>
            </Route>
            <Route path="users/:userID" let:params>
              <UserDetails userID={params.userID} />
            </Route>
            <Route path="users/:userID/edit" let:params>
              <div in:fade>
                <UserForm
                  userID={params.userID}
                  formType="edit"
                />
              </div>
            </Route>
          </Route>
        </AdminOnly>
        <Route path="/company-management/*">
          <Route path="" let:params>
            <div in:fade>
              <CompanyList />
            </div>
          </Route>
          <Route path="all">
            <div in:fade>
              <CompanyList />
            </div>
          </Route>
          <Route path="new" let:params>
            <div in:fade>
              <CompanyForm />
            </div>
          </Route>
          <Route path=":companyID" let:params>
            <CompanyDetails companyID={params.companyID}/>
          </Route>
          <Route path=":companyID/edit" let:params>
            <div in:fade>
              <CompanyForm companyID={params.companyID} />
            </div>
          </Route>
        </Route>
        <Route path="/stock-management/*">
          <Route path="" let:params>
            <div in:fade>
              <StockList />
            </div>
          </Route>
          <Route path="all">
            <div in:fade>
              <StockList />
            </div>
          </Route>
          <Route path="new" let:params>
            <div in:fade>
              <StockForm />
            </div>
          </Route>
          <Route path=":stockID" let:params>
            <StockDetails stockID={params.stockID} />
          </Route>
          <Route path=":stockID/edit" let:params>
            <div in:fade>
              <StockForm stockID={params.stockID} />
            </div>
          </Route>
        </Route>
        <Route path="/offer-management/*">
          <Route path="" let:params>
            <div in:fade>
              <OfferList />
            </div>
          </Route>
          <Route path="all">
            <div in:fade>
              <OfferList />
            </div>
          </Route>
          <Route path="new" let:params>
            <div in:fade>
              <OfferForm />
            </div>
          </Route>
          <Route path=":offerID" let:params>
            <OfferDetails offerID={params.offerID} />
          </Route>
          <Route path=":offerID/edit" let:params>
            <div in:fade>
              <OfferForm offerID={params.offerID} />
            </div>
          </Route>
        </Route>
        <Route path="/order-management/*">
          <Route path="" let:params>
            <div in:fade>
              <OrderList />
            </div>
          </Route>
          <Route path="all">
            <div in:fade>
              <OrderList />
            </div>
          </Route>
          <Route path="new" let:params>
            <div in:fade>
              <OrderForm />
            </div>
          </Route>
          <Route path=":orderID" let:params>
            <OrderDetails orderID={params.orderID} />
          </Route>
          <Route path=":orderID/edit" let:params>
            <div in:fade>
              <OrderForm orderID={params.orderID} />
            </div>
          </Route>
        </Route>
      </Router>
    </Content>
  {:else}
    <Route path="/">
      <AuthLayout formType="login" />
    </Route>
    <Route path="/forgot-password">
      <AuthLayout formType="forgotPassword" />
    </Route>
    <Route path="/reset-password">
      <AuthLayout formType="resetPassword" />
    </Route>
  {/if}
</Router>
